module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.notesDialog),
      callback: function($$v) {
        _vm.notesDialog = $$v
      },
      expression: "notesDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Edit Notes")]), _vm._v(" "), _c('v-card-text', [_c('v-textarea', {
    model: {
      value: (_vm.editNotes),
      callback: function($$v) {
        _vm.editNotes = $$v
      },
      expression: "editNotes"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.notesDialog = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": "",
      "loading": _vm.savingNotes
    },
    on: {
      "click": _vm.saveNotes
    }
  }, [_vm._v("Save")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.startAlert),
      callback: function($$v) {
        _vm.startAlert = $$v
      },
      expression: "startAlert"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Start Job")]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "value": _vm.activeJob.Allocated !== _vm.user.id,
      "color": "warning",
      "icon": "priority_high"
    }
  }, [_vm._v("\n        This job is not assigned to you "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.assigning
    },
    on: {
      "click": _vm.assignJob
    }
  }, [_c('v-icon', [_vm._v("assignment_ind")]), _vm._v("Assign")], 1)], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "value": _vm.activeJob.jobStarted,
      "color": "error",
      "icon": "priority_high"
    }
  }, [_vm._v("\n        This job has been flagged as started!\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you wish to start job "), _c('strong', [_vm._v(_vm._s(_vm.activeJob.JobNo))]), _vm._v(", any uncomplete jobs will be discarded?")]), _vm._v(" "), (_vm.activeJob.Allocated !== _vm.user.id) ? _c('v-card-text', [_vm._v("This job will be automatically assigned to you if you choose to continue.")]) : _vm._e(), _vm._v(" "), _c('v-subheader', [_vm._v("Summary")]), _vm._v(" "), _c('v-list', {
    attrs: {
      "dark": ""
    }
  }, _vm._l((_vm.templateSummary), function(template, i) {
    return _c('v-list-tile', {
      key: i
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(template))])], 1)
  }), 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.startAlert = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    on: {
      "click": _vm.startJob
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.continueAlert),
      callback: function($$v) {
        _vm.continueAlert = $$v
      },
      expression: "continueAlert"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Continue Job")]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you wish to continue job "), _c('strong', [_vm._v(_vm._s(_vm.activeJob.JobNo))]), _vm._v(", any uncomplete jobs will be discarded?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.continueAlert = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    on: {
      "click": _vm.continueJob
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1), _vm._v(" "), _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mb-3": ""
    }
  }, [(_vm.user.unassigned) ? _c('v-flex', {
    staticClass: "text-xs-left pr-2",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Filter by Engineer",
      "items": _vm.engineerSelect,
      "item-text": "text",
      "item-value": "value"
    },
    model: {
      value: (_vm.selectEngineer),
      callback: function($$v) {
        _vm.selectEngineer = $$v
      },
      expression: "selectEngineer"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-left pr-2",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Filter by Customer",
      "items": _vm.customers,
      "item-text": "name",
      "item-value": "id",
      "no-data-text": "No Results - Please type at least 3 characters",
      "search-input": _vm.customerFilter,
      "clearable": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.customerFilter = $event
      },
      "update:search-input": function($event) {
        _vm.customerFilter = $event
      }
    },
    model: {
      value: (_vm.selectCustomer),
      callback: function($$v) {
        _vm.selectCustomer = $$v
      },
      expression: "selectCustomer"
    }
  })], 1), _vm._v(" "), (_vm.jobVehicles.length > 0) ? _c('v-flex', {
    staticClass: "text-xs-left px-2",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Filter by Vehicle",
      "items": _vm.jobVehicles,
      "item-text": "reg",
      "item-value": "id",
      "clearable": ""
    },
    model: {
      value: (_vm.selectVehicle),
      callback: function($$v) {
        _vm.selectVehicle = $$v
      },
      expression: "selectVehicle"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Search by Job ID",
      "clearable": ""
    },
    model: {
      value: (_vm.jobFilter),
      callback: function($$v) {
        _vm.jobFilter = $$v
      },
      expression: "jobFilter"
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Include Completed",
      "color": "primary"
    },
    model: {
      value: (_vm.includeCompleted),
      callback: function($$v) {
        _vm.includeCompleted = $$v
      },
      expression: "includeCompleted"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [(_vm.listView) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.loading,
      "round": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        return _vm.getJobs()
      }
    }
  }, [_vm._v("Load Jobs")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right pl-2",
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_vm._v("\n        Layout: \n        "), _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary",
      "flat": !_vm.listView
    },
    on: {
      "click": function($event) {
        _vm.listView = !_vm.listView
      }
    }
  }, [_c('v-icon', [_vm._v("list")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary",
      "flat": _vm.listView
    },
    on: {
      "click": function($event) {
        _vm.listView = !_vm.listView
      }
    }
  }, [_c('v-icon', [_vm._v("today")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.listView),
      expression: "!listView"
    }],
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.yesterday()
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs10": ""
    }
  }, [_c('v-menu', {
    ref: "date",
    attrs: {
      "return-value": _vm.date,
      "lazy": "",
      "transition": "scale-transition"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    model: {
      value: (_vm.dateMenu),
      callback: function($$v) {
        _vm.dateMenu = $$v
      },
      expression: "dateMenu"
    }
  }, [_c('h2', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("today")]), _vm._v("\n          " + _vm._s(_vm.dateFormatted) + "\n        ")], 1), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dateMenu = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.date.save(_vm.date)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs1": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.tomorrow()
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.loading) ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 70,
      "width": 7,
      "color": "primary"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "color": "error",
      "icon": "cloud_off",
      "value": !_vm.online,
      "transition": "scale-transition"
    }
  }, [_vm._v("\n      No Connection, using saved data.\n    ")]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "color": "info",
      "value": !_vm.hasCustomers && !_vm.loading,
      "icon": "info_outline"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.listView ? 'You do not have any jobs' : 'You do not have any jobs on this day') + "\n    ")]), _vm._v(" "), (_vm.hasCustomers && !_vm.loading && _vm.vehicleFilteredJobs.length > 0) ? _vm._l((_vm.vehicleFilteredJobs), function(job, i) {
    return _c('v-list', {
      key: i,
      class: [(job.Status === 2 || _vm.outboxItems.indexOf(job.number) !== -1 ? 'green' : _vm.inProgressKeys[job.number] ? 'orange lighten-1' : ''), 'mb-2 pa-2'],
      attrs: {
        "dark": ""
      }
    }, [_c('v-list-tile', {
      attrs: {
        "three-line": ""
      }
    }, [_c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openEditNoteDialog(job)
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-pencil")])], 1)], 1), _vm._v(" "), _c('v-list-tile-content', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.activateJob(job)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(job.Vehicle ? _vm.vehicleRegFromID(job.Vehicle) : job.vehReg))]), _vm._v(" "), (job.Date) ? _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm._f("formatDate")(job.Date)))]) : _vm._e(), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Job ID: " + _vm._s(job.JobNo))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Project ID: " + _vm._s(job.Project))]), _vm._v("\n            " + _vm._s(job.notes) + "\n          ")], 1), _vm._v(" "), (_vm.isCurrentJob(job)) ? _c('v-icon', [_vm._v("schedule")]) : (_vm.outboxItems.indexOf(job.number) !== -1) ? _c('v-icon', [_vm._v("mdi-sync-off")]) : (_vm.inProgressKeys[job.number]) ? _c('v-icon', [_vm._v("mdi-progress-clock")]) : _vm._e()], 1)], 1)
  }) : _vm._e(), _vm._v(" "), (_vm.hasCustomers && !_vm.loading && _vm.selectCustomer && _vm.vehicleFilteredJobs.length === 0) ? [_c('h3', {
    staticClass: "text-xs-center"
  }, [_vm._v("No jobs found for this customer")])] : _vm._e()], 2), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "multi-line": "",
      "color": "error"
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbarText) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b741e466","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/JobList.vue
// module id = 677
// module chunks = 1